import { useCallback, useMemo } from 'react';

import { useStorageLimitBannerPermanentStore, useStorageLimitBannerSessionStore } from './useStorageLimitBannerStore';

type UseStorageLimitBannerDismissParams = {
  canEditPlan: boolean;
  isOutOfStorage: boolean;
};

export const useStorageLimitBannerDismiss = ({ canEditPlan, isOutOfStorage }: UseStorageLimitBannerDismissParams) => {
  const isSessionDismissed = useStorageLimitBannerSessionStore((s) => s.isDismissed);
  const dismissSession = useStorageLimitBannerSessionStore((s) => s.dismiss);
  const isPermanentlyDismissed = useStorageLimitBannerPermanentStore((s) => s.isDismissed);
  const dismissPermanent = useStorageLimitBannerPermanentStore((s) => s.dismiss);

  const isDismissed = useMemo(() => {
    if (isOutOfStorage) return false;
    return canEditPlan ? isSessionDismissed : isPermanentlyDismissed;
  }, [isOutOfStorage, canEditPlan, isSessionDismissed, isPermanentlyDismissed]);

  const dismiss = useCallback(() => {
    if (canEditPlan) {
      dismissSession();
    } else {
      dismissPermanent();
    }
  }, [canEditPlan, dismissSession, dismissPermanent]);

  return { isDismissed, dismiss };
};
